import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=aa55176c&scoped=true"
import script from "./DictList.vue?vue&type=script&lang=js"
export * from "./DictList.vue?vue&type=script&lang=js"
import style0 from "./DictList.vue?vue&type=style&index=0&id=aa55176c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55176c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa55176c')) {
      api.createRecord('aa55176c', component.options)
    } else {
      api.reload('aa55176c', component.options)
    }
    module.hot.accept("./DictList.vue?vue&type=template&id=aa55176c&scoped=true", function () {
      api.rerender('aa55176c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictList.vue"
export default component.exports